<app-modal title="{{ 'Add User Group' }}" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">
    <div class="mb-3">
      <label for="email">Email</label>
      <input class="form-control"
             type="text"
             id="email"
             name="email"
             [ngModel]="groupEmail()"
             (ngModelChange)="groupEmail.set($event)"
             required
             email
             #email="ngModel">
      @if (email.errors && email.touched) {
        <div class="form-error-message">
          @if (email.errors.required) {
            <p>Email is required</p>
          } @if (email.errors.email) {
          <p>Email is invalid</p>
        }
        </div>
      }
    </div>

    <div class="mb-3">
      <label for="role">Description</label>
      <input class="form-control"
             type="text"
             id="role"
             name="role"
             [ngModel]="groupDescription()"
             (ngModelChange)="groupDescription.set($event)"
             required
             #role="ngModel">
      @if (role.errors && role.touched) {
        <div class="form-error-message">
          @if (role.errors.required) {
            <p>Role is required</p>
          }
        </div>
      }
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || loading()">Save
      </button>
    </div>
  </form>
</app-modal>